export default __webpack_public_path__ + "static/media/searchIcon.a4612281.svg";